(function () {
  'use strict';
  if (window.AUVENNEPdpFinalCroBound) return;
  window.AUVENNEPdpFinalCroBound = true;

  var observer = null;

  function isSwedish() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('sv') === 0;
  }

  function ui(nl, sv) {
    return isSwedish() ? sv : nl;
  }

  function displayValue(value) {
    var map = isSwedish()
      ? { 'Gold Color': 'Guldfärg', 'Silver Color': 'Silverfärg', 'Gold tone': 'Guldfärg', 'Silver tone': 'Silverfärg', 'One Size': 'En storlek' }
      : { 'Gold Color': 'Goudkleur', 'Silver Color': 'Zilverkleur', 'Gold tone': 'Goudkleur', 'Silver tone': 'Zilverkleur', 'One Size': 'Eén maat' };
    return map[value] || value || '';
  }

  function placeOffer(buy) {
    if (buy.querySelector('[data-legame-bundle]')) return;
    var existing = buy.querySelector('[data-auv-pdp-final-offer]');
    var actions = buy.querySelector('.lu-pdp__actions');
    if (existing) {
      if (buy.closest('[data-auv-approved-pdp]') && actions && existing.nextElementSibling !== actions) actions.insertAdjacentElement('beforebegin', existing);
      return;
    }
    var source = document.querySelector('[data-auv-pdp-final-offer-source]');
    var offer = source && source.querySelector('[data-auv-pdp-final-offer]');
    if (!offer) return;
    if (buy.closest('[data-auv-approved-pdp]') && actions) {
      actions.insertAdjacentElement('beforebegin', offer.cloneNode(true));
      return;
    }
    var review = buy.querySelector('[data-auv-review-summary]:not([hidden])');
    var price = buy.querySelector('[data-lu-price]');
    var anchor = review || price;
    if (anchor) anchor.insertAdjacentElement('afterend', offer.cloneNode(true));
  }

  function placeFacts(buy) {
    if (buy.querySelector('[data-auv-pdp-final-facts]')) return;
    var source = document.querySelector('[data-auv-pdp-final-facts-source]');
    var facts = source && source.querySelector('[data-auv-pdp-final-facts]');
    var actions = buy.querySelector('.lu-pdp__actions');
    if (facts && actions) actions.insertAdjacentElement('beforebegin', facts.cloneNode(true));
  }

  function selectedLabels(buy) {
    buy.querySelectorAll('.lu-pdp__opt').forEach(function (option) {
      var heading = option.querySelector(':scope > span');
      var radios = Array.prototype.slice.call(option.querySelectorAll('input[type="radio"]'));
      if (!heading || !radios.length) return;
      if (!heading.id) heading.id = radios[0].id + '-group-label';
      var group = option.querySelector('.lu-swatch');
      if (group) {
        group.setAttribute('role', 'radiogroup');
        group.setAttribute('aria-labelledby', heading.id);
      }
      var output = heading.querySelector('[data-auv-pdp-final-selected]');
      if (!output) {
        output = document.createElement('em');
        output.className = 'auv-pdp-final-selected';
        output.setAttribute('data-auv-pdp-final-selected', '');
        heading.appendChild(output);
      }
      var update = function () {
        var selected = radios.find(function (radio) { return radio.checked; });
        output.textContent = selected ? displayValue(selected.value) : ui('Maak een keuze', 'Gör ett val');
      };
      radios.forEach(function (radio) {
        if (radio.getAttribute('data-auv-pdp-final-listener') === 'true') return;
        radio.setAttribute('data-auv-pdp-final-listener', 'true');
        radio.addEventListener('change', update);
      });
      update();
    });
  }

  function galleryHint(root) {
    var controls = root.querySelector('.lu-pdp__gallery-controls');
    if (!controls || controls.querySelector('[data-auv-pdp-final-gallery-hint]')) return;
    var hint = document.createElement('span');
    hint.className = 'auv-pdp-final-gallery-hint';
    hint.setAttribute('data-auv-pdp-final-gallery-hint', '');
    hint.textContent = ui('Veeg voor detail', 'Svep för detaljer');
    controls.appendChild(hint);
  }

  function localizeGalleryAlts(root) {
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-lu-gallery] img'));
    var heading = root.querySelector('.lu-pdp__title');
    var productTitle = heading && heading.textContent.trim() ? heading.textContent.trim() : ui('AUVENNE-sieraad', 'AUVENNE-smycke');
    images.forEach(function (image, index) {
      image.alt = ui(
        productTitle + ' – productbeeld ' + (index + 1) + ' van ' + images.length,
        productTitle + ' – produktbild ' + (index + 1) + ' av ' + images.length
      );
    });
  }

  function localizeFloralDetails(buy) {
    var source = document.querySelector('[data-auv-pdp-final-details-source] [data-auv-pdp-final-details]');
    var target = buy.querySelector('.lu-pdp__details-in .lu-rte');
    if (!source || !target || target.getAttribute('data-auv-pdp-final-details-ready') === 'true') return;
    target.innerHTML = source.innerHTML;
    target.setAttribute('data-auv-pdp-final-details-ready', 'true');
  }

  function stickyTiming(root) {
    var mainButton = root.querySelector('[data-lu-add]');
    var sticky = document.querySelector('[data-lu-sticky]');
    if (!mainButton || !sticky) return;
    sticky.classList.add('auv-pdp-final-sticky');
    if (sticky.getAttribute('data-auv-pdp-final-observed') === 'true') return;
    sticky.setAttribute('data-auv-pdp-final-observed', 'true');

    var setVisible = function (visible) {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    setVisible(false);
    if (!('IntersectionObserver' in window)) {
      var fallback = function () {
        var rect = mainButton.getBoundingClientRect();
        setVisible(rect.bottom < 0);
      };
      window.addEventListener('scroll', fallback, { passive: true });
      fallback();
      return;
    }

    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0.15 });
    observer.observe(mainButton);
  }

  function enhance() {
    var root = document.querySelector('[data-lu-pdp]');
    if (!root) return;
    var buy = root.querySelector('.lu-pdp__buy');
    if (!buy) return;
    placeOffer(buy);
    placeFacts(buy);
    selectedLabels(buy);
    galleryHint(root);
    localizeGalleryAlts(root);
    localizeFloralDetails(buy);
    stickyTiming(root);
    root.setAttribute('data-auv-pdp-final-ready', 'true');
  }

  function start() {
    enhance();
    window.requestAnimationFrame(enhance);
    window.setTimeout(enhance, 120);
    window.setTimeout(enhance, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
